module.exports = __webpack_public_path__ + "img/amivtac.7188bf92.png";